export const MAX_ASSET_MB = 5;

export const AVATAR_FIELDS = [
  {
    key: "avtar1",
    label: "Female",
    width: 250,
    height: 250,
    defaultFile: "avtar1.png",
    canDelete: true,
  },
  {
    key: "avtar2",
    label: "Male",
    width: 250,
    height: 250,
    defaultFile: "avtar2.png",
    canDelete: true,
  },
];

export const SNAKE_FIELDS = [
  { key: "snake1", label: "Snake 1", width: 140, height: 356 },
  { key: "snake2", label: "Snake 2", width: 359, height: 497 },
  { key: "snake3", label: "Snake 3", width: 221, height: 306 },
  { key: "snake4", label: "Snake 4", width: 220, height: 306 },
  { key: "snake5", label: "Snake 5", width: 261, height: 156 },
];

export const LADDER_FIELDS = [
  { key: "ladder1", label: "ladder 1", width: 119, height: 195 },
  { key: "ladder2", label: "ladder 2", width: 192, height: 279 },
  { key: "ladder3", label: "ladder 3", width: 139, height: 217 },
];

export function toColorInputValue(val, fallback = "#000000") {
  if (!val || typeof val !== "string") return fallback;
  const v = val.trim();
  if (/^#[0-9a-fA-F]{6}$/.test(v)) return v.toLowerCase();
  if (/^#[0-9a-fA-F]{8}$/.test(v)) return `#${v.slice(1, 7).toLowerCase()}`;
  return fallback;
}

export function fileBaseName(value) {
  return String(value || "")
    .split(/[\\/]/)
    .pop()
    .split("?")[0];
}

export function isDefaultAvatarValue(value, field) {
  const base = fileBaseName(value).toLowerCase();
  return base === String(field.defaultFile || "").toLowerCase();
}

export function readImageSize(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve({
        width: img.naturalWidth || img.width,
        height: img.naturalHeight || img.height,
      });
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Could not read image file."));
    };
    img.src = url;
  });
}

export async function validatePngAsset(file, field) {
  const label = field.label;
  if (!file) return `Please choose an image for ${label}.`;
  const type = String(file.type || "").toLowerCase();
  const ext = (file.name.split(".").pop() || "").toLowerCase();
  if (type !== "image/png" && ext !== "png") {
    return `${label} must be a PNG file.`;
  }
  if (file.size > MAX_ASSET_MB * 1024 * 1024) {
    return `${label} must not exceed ${MAX_ASSET_MB} MB.`;
  }
  try {
    const { width, height } = await readImageSize(file);
    if (width !== field.width || height !== field.height) {
      return `${label} must have dimensions ${field.width}x${field.height}.`;
    }
  } catch {
    return `Failed to load ${label} for dimension validation.`;
  }
  return null;
}
